import { useState, useRef } from "react";
import {
  Col,
  Row,
  Typography, Form,
  Input,
  Button,
  Select,
  Layout,
  Skeleton,
} from "../../components/ui";
import { debounce } from "lodash";
import { useDeleteClass, useGetClassById, useUpdateClass, useSearchTeachers } from "../../query/classQuery";
import { FaArrowLeft } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import swal from "../../utils/swal";
import ClassProfile from "./ClassProfile";
import ClassColorPicker from "./ClassColorPicker";
import { DEFAULT_CLASSROOM_COLOR } from "../../config/classroomColors";
import "./classroom.css";
function ClassDetails() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { id } = useParams();
  const editMode = pathname.includes("/edit/");
  const { isLoading, data: classroom } = useGetClassById(id);
  const { mutate: updateClass, isPending: isMutating } = useUpdateClass();
  const { mutate: deleteClass } = useDeleteClass();
  const [loading, setLoading] = useState(false);
  const [searchTeacher, setSearchTeacher] = useState();


  const { isLoading: isFetching, data: teachers } = useSearchTeachers({
    keyword: searchTeacher,
  });

  const handleDelete = async () => {
    if ((classroom?.students || []).length > 0) {
      swal(
        "Cannot delete",
        "This class still has students assigned. Reassign or remove the students first.",
        "warning"
      );
      return;
    }

    swal({
      title: "Are you sure?",
      text: "Do you want to delete this Class?",
      icon: "warning",
      buttons: ["No, cancel it!", "Yes, I am sure!"],
      dangerMode: true,
    }).then(async function (isConfirm) {
      if (isConfirm) {
        deleteClass(id, {
          onSuccess: () => {
            swal("Success", "Class deleted successfully", "success");
            navigate("/classes");
          },
          onError: (error) => {
            swal("Cannot delete", error?.message || "Failed to delete class", "error");
          },
        });
      }
    });
  };


  const debouncedSearchTeacher = useRef(
    debounce((value) => {
      setSearchTeacher(value); // Update the search term after debounce delay
    }, 1500)
  ).current;




  const onFinish = (values) => {
    updateClass({ classId: id, data: values }, {
      onSuccess: () => {
        swal("Success", "Class updated successfully", "success");
        navigate(`/classes/${id}`);
      },
      onError: (error) => {
        swal("Error", error?.message, "error");
      },
    });
  };

  return (
    <Layout className="configuration">
      <div
        className="boxDetails"
        style={editMode ? undefined : { background: "transparent", padding: 0, boxShadow: "none" }}
      >
        {editMode && (
        <Row style={{ padding: "10px" }}>
          <Col
            xs={24}
            md={12}
            style={{ display: "flex", alignItems: "center" }}
          >
            <FaArrowLeft
              style={{ fontWeight: "bold", fontSize: "20px", cursor: "pointer" }}
              onClick={() => navigate(`/classes/${id}`)}
            />
            &emsp;
            <h1 className="pageTitle" style={{ margin: 0 }}>
              Edit Class
            </h1>
          </Col>
        </Row>
        )}

        {isLoading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
              marginBottom: "20px",
              marginTop: "20px",

            }}
          >
            <br />            <br />

            <Skeleton active paragraph={{ rows: 10 }} />
          </div>
        )}

        {!isLoading && classroom && (
          <>
            {editMode ? <Form
              layout="vertical"
              name="basic"
              className="contactForm"
              labelCol={{
                span: 0,
              }}
              wrapperCol={{
                span: 24,
              }}
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              // onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Row gutter={20} style={{ padding: "0px 20px" }}>
                <Col
                  xs={24}
                  sm={8}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    Class Id :
                  </Typography.Title>

                  <Form.Item
                    name="classroomId"
                    initialValue={classroom?.classroomId}
                    style={{ width: "100%" }}
                    
                  >
                    <Input
                      size="large"
                      placeholder="Enter Class Id"
                      className="signupFormInput"
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={8}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    Class Name :
                  </Typography.Title>

                  <Form.Item
                    name="classroomName"
                    initialValue={classroom?.classroomName}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input Class Name",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Enter Class Name"
                      className="signupFormInput"
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={8}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    Class Grade :
                  </Typography.Title>

                  <Form.Item
                    name="classroomGrade"
                    initialValue={classroom?.classroomGrade}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input Class Grade",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Enter Class Grade"
                      className="signupFormInput"
                    />
                  </Form.Item>
                </Col>
              <Col
                  xs={24}
                  sm={8}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    Class Batch :
                  </Typography.Title>

                  <Form.Item
                    name="classroomBatch"
                    initialValue={classroom?.classroomBatch}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input Class Batch",
                      },
                    ]}
                  >
                    <Input
                      style={{ width: "100%" }}
                      size="large"
                      placeholder="Enter Class Batch"
                      className="signupFormInput"
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={8}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    Section Color :
                  </Typography.Title>

                  <Form.Item
                    name="color"
                    initialValue={classroom?.color || DEFAULT_CLASSROOM_COLOR}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: "Please select a section color",
                      },
                    ]}
                  >
                    <ClassColorPicker />
                  </Form.Item>
                </Col>

                <Col
                  xs={24}
                  sm={8}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    Teacher :
                  </Typography.Title>

                  <Form.Item
                    name="teacher"
                    initialValue={classroom?.teacher?._id || ""}
                    style={{ width: "100%" }}
                    
                    
                  >
                    <Select
                      showSearch
                      size={"large"}
                      className="selectBox"
                      placeholder="Search Teacher"
                      onSearch={(e) => { setLoading(true); debouncedSearchTeacher(e) }}
                      // value={selectedParent ? selectedParent : searchParent}
                      onChange={(e) => {
                        setLoading(false);
                      }}
                      // }
                      style={{
                        width: "100%",
                        marginBottom: "10px",
                        textAlign: "left",
                      }}

                      options={teachers?.map((teacher) => ({
                        value: teacher._id,
                        label: teacher.firstName + " " + teacher.lastName + " (" + teacher.teacherId + ")",
                      }))}
                      filterOption={(input, option) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                      loading={loading || isFetching}
                    />
                  </Form.Item>
                </Col>

                <Col
                  xs={24}
                  sm={8}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                  <Typography.Title
                    className="fontFamily1"
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "black",
                      textAlign: "left",
                      marginBottom: 20,
                    }}
                  >
                    Description
                  </Typography.Title>

                  <Form.Item
                    name="description"
                    initialValue={classroom?.description}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input description",
                      },
                    ]}
                  >
                    <Input

                      size="large"
                      placeholder="Enter description"
                      className="signupFormInput"
                    />
                  </Form.Item>
                </Col>
              </Row>


              <Row style={{ padding: "10px 20px" }}>
                <Form.Item label={null}>
                  <Button type="primary" htmlType="submit" className="saveBtn" disabled={isMutating}>
                    {isMutating ? "Loading..." : "Save"}
                  </Button>&emsp;<Button
                    type="primary"
                    htmlType="submit"
                    className="cancelBtn"
                    ghost
                    onClick={() => navigate(`/classes/${id}`)}

                  >
                    Cancel
                  </Button>
                </Form.Item>
              </Row>

            </Form> : (
              <ClassProfile
                classroom={classroom}
                onDelete={handleDelete}
              />
            )}
          </>
        )}
      </div>
    </Layout>
  );
}
export default ClassDetails;
